import {
  ModalAction,
  ModalBody,
  ModalFooter,
  ModalFooterActions,
  ModalHeader,
  ModalV2,
  Spacer,
  spaces,
  Text,
} from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import safelyOpenExternalURL from 'common/safelyOpenExternalURL';

type SupportRedirectModalProps = {
  onClose: () => void;
  redirectUrl: string;
  // True when the org has actually exhausted its licenses — keeps the
  // "License limit reached" copy accurate for that case. False for entry
  // points where a user proactively asks to add licenses (e.g. BasePlanTile),
  // where that framing would be misleading.
  isAtLimit: boolean;
};

const SupportRedirectModal = ({
  onClose,
  redirectUrl,
  isAtLimit,
}: SupportRedirectModalProps) => {
  const { t } = useTranslation('people');

  const titleKey = isAtLimit
    ? 'licenseLimitReachedModal.selfService.title'
    : 'supportRedirectModal.title';
  const bodyKey = isAtLimit
    ? 'licenseLimitReachedModal.selfService.supportRedirect.body'
    : 'supportRedirectModal.body';
  const ctaKey = isAtLimit
    ? 'licenseLimitReachedModal.selfService.supportRedirect.cta'
    : 'supportRedirectModal.cta';

  const handleContactSupport = () => {
    safelyOpenExternalURL(redirectUrl);
  };

  return (
    <ModalV2 ariaLabelledby="support-redirect-modal" hide={onClose} visible>
      <ModalHeader>
        <Text id="support-redirect-modal" variant="heading-2">
          {t(titleKey)}
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text>{t(bodyKey)}</Text>
        <Spacer space={spaces.space_l} />
      </ModalBody>
      <ModalFooter>
        <ModalFooterActions>
          <ModalAction
            id="support-redirect-cancel-button"
            variant="text"
            onClick={onClose}>
            {t('licenseLimitReachedModal.cancel')}
          </ModalAction>
          <ModalAction
            id="support-redirect-contact-support-button"
            onClick={handleContactSupport}>
            {t(ctaKey)}
          </ModalAction>
        </ModalFooterActions>
      </ModalFooter>
    </ModalV2>
  );
};

export default SupportRedirectModal;
